import React from 'react';
import IconValueCardRow, { Props as IconValueCardRowProps } from "../Card";
import LcLoading from '../../Generic/LcLoading';
import HHClickList from '../../Data/HHClickList';

interface CardData {
  title: IconValueCardRowProps['title'];
  value: IconValueCardRowProps['value'];
  color: IconValueCardRowProps['color'];
  icon: IconValueCardRowProps['icon'];
}

interface CardDetailedProps extends IconValueCardRowProps {
  cardData: CardData;
  clickListData: any[]
  onClick?: (row: any) => void
  onClickLine?: (row: any) => void
  loading?: boolean
  detailed: boolean
}

const CardDetailed: React.FC<CardDetailedProps> = ({ cardData, detailed, clickListData, onClick, onClickLine, loading, ...restProps }) => {
  const columns: any = [
    { header: "", name: "id", width: '0px', color: 'black', hidden: true },
    {
      header: "",
      name: "descricao",
      width: '70%',
      color: 'black',
      renderCell: (row: any) => {
        return (<span style={{ cursor: "pointer" }} onClick={() => { onClickLine && onClickLine(row) }}>{row.descricao}</span>)
      }
    },
    {
      header: "",
      name: "count",
      width: '30%',
      align: 'right',
      color: 'black',
      bold: true,
      renderCell: (row: any) => {
        return (<span style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }} onClick={() => { onClickLine && onClickLine(row) }}>{row.count}</span>)
      }
    }
  ];

  return (
    <div
      className={`chartbox ${!detailed && "wDash32p"} boxShadowLightBlack`}
      style={{
        // overflow: 'hidden',
        minHeight: "100%",
        width: "49%",
        marginRight: "0px",
        justifyContent: 'space-between'
      }}>
      <IconValueCardRow {...cardData} {...restProps} />
      {
        detailed &&
        <LcLoading loading={loading}>
          <div className='row start' style={{ paddingLeft: '12px', paddingRight: '12px' }}>
            <HHClickList
              columns={columns}
              data={clickListData}
              onCLick={onClick}
              rowLink={true}
            />
          </div>
        </LcLoading>
      }
    </div>
  );
}

export default CardDetailed;